import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import reactStringReplace from 'react-string-replace'
import { v4 } from 'uuid'

import Card from '@/components/Card/Card'
import Mana, { ManaType } from '@/components/Mana/Mana'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import Panel from '@/components/Panel/Panel'
import { CardListType } from '@/types/card'
import { ComboData } from '@/types/page'

import styles from './ComboDescription.module.scss'

const format = (input: string) =>
  reactStringReplace(input, /\{([^}]+)\}/, (match) => <Mana color={match as ManaType} />)

type Props = { combo: ComboData; headerList: CardListType }

const ComboDescription = ({ combo, headerList }: Props) => {
  const { combo_id, process_txt, require_txt, results_txt } = combo

  return (
    <Panel>
      <div className='d-flex flex-wrap gap-2'>
        {headerList.cardviews.map((card, i) => (
          <Card card={card} key={i} />
        ))}
      </div>
      {combo && (
        <>
          <hr className='my-3' />
          <h5>Requires</h5>
          <div className='mb-4'>{format(require_txt)}</div>
          <h5>Steps</h5>
          <ol>
            {process_txt.map((step) => (
              <li key={v4()}>{format(step)}</li>
            ))}
          </ol>
          <h5>Results</h5>
          <div>{results_txt}</div>
          <hr className='my-3' />
        </>
      )}
      <div className={styles.comboButtons}>
        <div className={styles.row}>
          {/* <span>View on:</span> */}
          <Form.Group className='m-0'>
            <OutboundLink
              className='me-2'
              title='View combo'
              url={`https://commanderspellbook.com/combo/${combo_id}/`}
              utm_medium='combo_links'
            >
              <Button size='sm'>View on Commander Spellbook</Button>
            </OutboundLink>
            {/* TODO: Enable when Archidekt multi-card search is faster */}
            {/* <OutboundLink
              alt="View combo"
              className="me-2"
              url={`https://commanderspellbook.com/combo/${combo_id}/`}
              utm_medium="combo_links"
            >
              <Button size="sm">Commander Spellbook</Button>
            </OutboundLink>
            <OutboundLink alt="View on Archidekt" className="me-2" url={comboArchidekt} utm_medium="combo_links">
              <Button size="sm">Archidekt</Button>
            </OutboundLink>
            <OutboundLink alt="View on Deckstats" url={comboDeckstats} utm_medium="combo_links">
              <Button size="sm">Decksta ts</Button>
            </OutboundLink> */}
          </Form.Group>
        </div>
        <div className={styles.row}>
          <Form.Group className='m-0'>
            <OutboundLink
              title='Report combo'
              url={`https://commanderspellbook.com/report-error?comboId=${combo_id}`}
              utm_medium='combo_links'
            >
              <Button size='sm' variant='danger'>
                Report error
              </Button>
            </OutboundLink>
          </Form.Group>
        </div>
      </div>
    </Panel>
  )
}

export default ComboDescription
